export default {
  "agentManagement": {
    "runtime": {
      "action": "功能接入",
      "title": "功能接入 · {{name}}",
      "feature": "功能方案",
      "selectFeature": "请选择功能方案",
      "feature_change_color": "一键换色",
      "feature_poster_standard": "AI海报图 · 标准",
      "feature_image_fission": "图片裂变",
      "feature_batch_matting": "批量抠图",
      "feature_ai_model": "AI换模特",
      "feature_replace_item": "商品替换",
      "feature_model_background_reference": "模特换背景 · 有参考图",
      "feature_model_background_no_reference": "模特换背景 · 无参考图",
      "model_pairHelp": "模特换背景使用两个智能体，两种方案同时切换；可见度和发布状态仍分别管理。",
      "model_pairBind": "同时切换模特换背景两种方案",
      "model_pairBindTitle": "同时切换模特换背景两种方案？",
      "model_pairUnbind": "恢复模特换背景两种原执行方式",
      "model_pairUnbindTitle": "恢复模特换背景两种原执行方式？",
      "feature_product_background_reference": "商品换背景 · 有参考图",
      "feature_product_background_no_reference": "商品换背景 · 无参考图",
      "pairHelp": "商品换背景使用两个智能体，两种方案同时切换；可见度和发布状态仍分别管理。",
      "pairPartner": "选择{{feature}}智能体",
      "pairSearch": "按智能体名称或标识搜索",
      "pairPartnerInvalid": "尚未核对到匹配的生效内容。请重新读取，或先核对并生效对应方案后再选择。",
      "pairSearchFailed": "暂时无法读取智能体，请重新搜索或刷新实际状态。",
      "pairCurrentMismatch": "请先选择与当前智能体生效内容一致的功能方案。",
      "pairBind": "同时切换商品换背景两种方案",
      "pairBindTitle": "同时切换商品换背景两种方案？",
      "pairBindBody": "原绑定：{{before}}。新绑定：{{after}}。当前智能体：{{current}}。另一智能体：{{name}} · {{partner}}。两种方案一次变更后用于新请求；已受理任务保持原内容和价格。",
      "pairUnbind": "恢复商品换背景两种原执行方式",
      "pairUnbindTitle": "恢复商品换背景两种原执行方式？",
      "pairUnbindBody": "原绑定：{{before}}。两种方案将同时解除绑定，新请求恢复原执行方式；已受理任务保持原快照，不会再次扣费。",
      "feature_poster_quality": "AI海报图 · 优质",
      "bindingReadFailed": "暂时无法读取所选功能入口，请确认服务已就绪后重新读取。",
      "scope": "草稿保存不会改变当前生效快照。新请求使用生效内容，已受理任务保留原快照与计费。",
      "readFailed": "无法读取运行配置。此环境可能尚未启用发布管理；请确认服务就绪后重新读取。",
      "releaseFailed": "所选发布内容读取失败，请重新读取后核对。",
      "writeUnconfirmed": "本次操作结果尚未确认，已暂停后续修改。请重新读取实际状态后再决定。",
      "refresh": "重新读取",
      "saved": "操作成功，正在核对最新状态。",
      "policyInvalid": "计费设置无效，请选择计费方式，固定计费时填写有效的单次算力。",
      "confirm": "确认生效",
      "cancel": "取消",
      "close": "关闭",
      "fixedSummary": "每次执行 {{points}} 算力",
      "dynamic": "按工作流节点动态计费",
      "maximum": "最多执行 {{count}} 次",
      "image": "张（一次执行一张）",
      "set": "套（一次执行多张）",
      "active": "当前生效内容",
      "notPublished": "尚未生效",
      "binding": "功能入口",
      "boundHere": "已绑定当前智能体",
      "boundOther": "已绑定智能体 {{id}}",
      "unbound": "未绑定，使用原执行方式",
      "prepareTab": "准备发布内容",
      "configurationSource": "数量和输出沿用现有智能体配置；工作流文件与智能体配置中不增加计费字段，也无需提供额外策略文件。",
      "prepareHelp": "先保存从 ComfyUI 导出的工作流、API 图及符合规范的中英文智能体配置。这里仅设置该智能体的计费方式和单次算力；固定总价为单价 × 执行次数。",
      "billing": "计费方式",
      "fixed": "按执行次数固定计费",
      "points": "每次执行所需算力",
      "required": "请选择或填写此项。",
      "prepare": "生成待核对快照",
      "releaseTab": "核对与生效 / 回退",
      "selectRelease": "选择发布快照",
      "current": "当前生效",
      "allOutputs": "配置声明的所有输出均为必需；缺失或保存不完整时，该次执行失败并退回实扣。",
      "policy": "运行策略",
      "configCn": "中文表单",
      "configEn": "英文表单",
      "workFlowApi": "执行图",
      "workFlow": "编辑图",
      "reviewed": "已核对所选快照的工作流、中英文配置和计费。",
      "activateTitle": "生效所选快照？",
      "activateBody": "智能体：{{name}}。由 {{before}} 切换为 {{after}}；{{summary}}。新请求将使用此内容和计费；选择历史快照即回退。",
      "activate": "生效所选内容",
      "bindingTab": "功能入口绑定",
      "bindingHelp": "仅已生效且与所选功能方案匹配的智能体可绑定。AG 列仍单独控制展示；绑定不会自动修改可见性或上线状态。",
      "bind": "将所选入口绑定到当前智能体",
      "bindTitle": "切换功能入口？",
      "bindBody": "功能：{{feature}}。原绑定：{{before}}；新绑定：{{name}}（{{after}}）。{{summary}}。后续请求将使用当前生效快照。",
      "unbind": "解除所选入口绑定",
      "unbindTitle": "恢复所选功能的原执行方式？",
      "unbindBody": "解除{{feature}}绑定后，该入口的新请求恢复原执行方式。已受理任务继续使用原快照，不重新计费。"
},
    "workflowEditAction": "编辑工作流",
    "workflowEditReading": "正在读取最新工作流内容，完成前暂不能保存。",
    "workflowEditReadFailed": "暂时无法确认最新工作流内容，未允许保存。请重新读取后再编辑。",
    "workflowEditReadRetry": "重新读取",
    "workflowEditConflict": "工作流已被其他操作修改。请保留当前修改，关闭后重新打开并比较。",
    "navigation": "管理导航",
    "openNavigation": "打开导航菜单",
    "feishuConfirmOwnershipBody": "同步目标：{{environment}}。以下新建内容将使用所列创建者、归属团队和可见团队，并保存为待验证。请确认账号与接收范围正确。",
    "feishuSyncTask": "飞书内容同步任务",
    "feishuResetView": "返回来源选择",
    "feishuConfirmTitle": "确认同步内容",
    "feishuReplaceOnlineBody": "将替换{{environment}}中 {{count}} 项已上线内容，并保留其当前发布状态。请核对变更和目标归属。",
    "feishuChanges": "内容变化",
    "feishuNewContent": "新增全部内容",
    "feishuOtherChanges": "其他内容",
    "feishuNoChanges": "未检测到内容变化",
    "previewChangesUnavailable": "暂无法比较内容，请核对预检结果",
    "feishuDiff_titleCn": "中文名称",
    "feishuDiff_titleEn": "英文名称",
    "feishuDiff_coverImage": "封面",
    "feishuDiff_detail": "中文详情",
    "feishuDiff_detailEn": "英文详情",
    "feishuDiff_node": "节点依赖",
    "feishuDiff_workFlow": "工作流内容",
    "feishuDiff_workFlowApi": "执行配置",
    "feishuDiff_courseCn": "中文教程",
    "feishuDiff_courseEn": "英文教程",
    "feishuDiff_showType": "展示范围",
    "feishuDiff_canDownload": "下载权限",
    "feishuDiff_joinDiscount": "折扣设置",
    "feishuDiff_recommend": "推荐设置",
    "feishuDiff_points": "评分",
    "feishuDiff_configCn": "中文参数配置",
    "feishuDiff_configEn": "英文参数配置",
    "feishuDiff_classification": "分类",
    "feishuDiff_label": "标签",
    "feishuTitle": "从飞书同步",
    "feishuRead": "读取来源",
    "feishuReadAgain": "重新读取来源",
    "feishuSelect": "选择内容与归属",
    "feishuPreview": "预检与确认",
    "feishuNote": "读取和预检不会修改飞书或当前内容。现有对象保留当前状态与归属，新建对象默认为待验证；确认后才写入。",
    "feishuLoading": "正在读取来源与记录",
    "feishuLoadFailed": "来源与记录读取失败，请重试。",
    "feishuUnavailable": "当前环境尚未启用飞书来源。请联系管理员核对表格与素材的读取配置。",
    "feishuSource": "飞书来源",
    "feishuRecords": "读取与准备记录",
    "previewDeadlines": "预检时限",
    "previewConfirmDeadline": "确认截止：{{time}}",
    "previewRetentionDeadline": "已准备内容保留至：{{time}}；重新预检不延长期限。",
    "feishuRecheck": "复用内容重新预检",
    "feishuRecheckNote": "仅使用本次已准备的附件和素材重新核对当前目标，不读取飞书最新内容，也不延长内容保留期限。更新来源请重新读取。",
    "feishuRecheckUnavailable": "本次内容不支持复用或已到保留期限，请重新读取来源并准备内容。",
    "feishuReviewExpired": "查看原预检",
    "feishuRetrySubmit": "重试同一提交",
    "feishuPrepare": "准备预检",
    "feishuTaskReadFailed": "暂时无法核对任务状态。可重试读取状态；请勿重复确认同步。",
    "feishuSubmitFailed": "任务提交未获确认，请重试同一操作；相同请求不会重复执行。",
    "feishuCloseHint": "可以关闭窗口，任务将继续。稍后可从读取与准备记录查看结果。",
    "feishuStage_QUEUED": "等待执行",
    "feishuStage_RUNNING": "正在读取或准备",
    "feishuStage_READY": "已完成",
    "feishuStage_FAILED": "未完成",
    "feishuStage_INTERRUPTED": "已中断",
    "feishuFailed": "读取或准备未完成，请核对来源后重试。",
    "feishuSearch": "名称或标识",
    "feishuSearchPlaceholder": "输入中文名、英文名或标识",
    "feishuMatches": "显示 {{count}} / {{total}} 条 · 已选 {{selected}} 条（含未显示内容）",
    "feishuSearchEmpty": "没有匹配内容，请修改或清空检索词",
    "feishuSnapshot": "来源：{{name}} · 读取完成：{{time}}",
    "feishuExpired": "本次读取已过期，请重新读取来源。",
    "feishuCatalogExpiredWithPreview": "来源目录已过期，重新准备前请重新读取来源。已有预检仍按其确认截止时间处理。",
    "feishuSourceIssues": "以下来源行需要修复，暂不可选择；其他有效行可单独选择预检。",
    "feishuShowSourceIssues": "查看 {{count}} 项问题",
    "feishuHideSourceIssues": "收起 {{count}} 项问题",
    "feishuKind": "内容类型",
    "feishuAgent": "智能体",
    "feishuWorkflow": "工作流",
    "feishuSourceState": "同步处理",
    "feishuDeleted": "来源已标记删除",
    "sourceOwnershipChecked": "本次已确认素材归属",
    "sourceOwnershipTitle": "来源素材归属核对",
    "sourceGroupId": "来源素材团队 ID",
    "sourceOwnershipHelp": "填写附件中素材实际所属的团队 ID；仅在确认为官方素材时填写 0。此处核对来源，不会改变目标创建者或团队，也不应照抄飞书的可见团队。",
    "sourceOwnershipConfirm": "我已核对这条记录的素材团队及使用范围",
    "sourceOwnershipScope": "仅用于本次读取目录中的所选内容和预检；不会新增素材读取权限，也不会自动公开团队私有素材。",
    "sourceOwnershipUnavailable": "部分内容的素材归属尚未核对，暂不可选择。请联系来源负责人确认使用范围；已核对的内容可继续准备。",
    "sourceOwnershipRequired": "请先逐项填写并确认所选内容的来源素材团队，再核对目标归属并准备预检。",
    "feishuSelectContent": "选择内容：{{name}}",
    "feishuTeamUnverified": "来源素材团队待核对",
    "feishuRow": "来源行",
    "feishuOwnershipSource": "请在当前环境指定并核对创建者和团队。飞书中的账号与团队不会自动作为目标归属。",
    "feishuPrepareSelection": "准备所选内容并预检（{{count}}）",
    "feishuPrepared": "预检已通过。请查看新增、更新和归属后确认同步。",
    "feishuReview": "查看同步预检",
    "feishuConfirmNote": "此预检绑定本次读取的附件、素材与当前目标内容。已有对象保留当前发布状态与归属；目标变化或预检过期后需要重新检查。",
    "feishuConfirm": "确认同步",
    "title": "智能体管理",
    "create": "新增智能体",
    "edit": "编辑智能体",
    "details": "查看详情",
    "delete": "删除智能体",
    "export": "导出发布包",
    "import": "导入发布包",
    "history": "迁移记录",
    "search": "名称或标识",
    "name": "名称",
    "sign": "稳定标识",
    "status": "发布状态",
    "OFFLINE": "已下线",
    "TEST": "待验证",
    "ONLINE": "已上线",
    "unknown": "状态未知",
    "save": "保存修改",
    "saveNew": "保存为待验证",
    "cancel": "取消",
    "retry": "重试",
    "basic": "基本信息",
    "config": "智能体参数",
    "execution": "执行配置",
    "visibility": "发布范围",
    "associationMode": "创建方式",
    "newWorkflow": "创建完整智能体",
    "existingWorkflow": "关联已有执行配置",
    "workFlowId": "选择已有工作流",
    "titleCn": "中文名称",
    "titleEn": "英文名称",
    "detailCn": "中文介绍",
    "detailEn": "英文介绍",
    "coverImageCn": "中文封面",
    "coverImageEn": "英文封面",
    "draftCoverHelp": "待验证时可稍后补齐，上线前需填写中英文封面。",
    "error_publicationCoverRequired": "上线前请先补齐{{field}}。",
    "classification": "分类",
    "labels": "标签",
    "configCn": "中文参数配置 JSON",
    "configEn": "英文参数配置 JSON",
    "workFlow": "编辑器工作流 JSON",
    "workFlowApi": "执行 API JSON",
    "node": "节点依赖说明",
    "courseCn": "中文教程链接",
    "courseEn": "英文教程链接",
    "userId": "创作者用户 ID",
    "groupId": "归属团队 ID",
    "owningGroupHelp": "填写创建者所属的有效团队；0 表示不限定归属团队，上线后的可见范围还受可见团队名单控制。",
    "confirmOwnershipSave": "确认归属与可见范围并保存",
    "confirmAndSave": "确认并保存",
    "ownershipSaveNote": "请核对当前环境的账号、团队和可见范围。待验证时仅创建者可在获授权的团队范围内验收。",
    "owningTeamAudience": "上线后，归属团队及可见团队名单可以访问。",
    "restrictedAudience": "上线后，仅可见团队名单内的团队可以访问。",
    "unrestrictedAudience": "上线后将无团队范围限制。",
    "error_teamCreator": "团队智能体请选择该团队的有效维护者，不能使用平台创建者 0。",
    "points": "评分",
    "canDownload": "允许下载",
    "verify": "已人工验证",
    "recommend": "推荐展示",
    "joinDiscount": "参与折扣",
    "joinMarket": "在市场展示",
    "showInWorkFlow": "同时在工作流入口展示",
    "sharedGroups": "可见团队",
    "groupsHelp": "使用 JSON 数组填写额外可见团队 ID，例如 [\"123\"]。空数组不增加共享团队；归属团队为 0 时，上线后将无团队范围限制。",
    "creatorHelp": "实际生成验收请填写有效用户 ID；创建者 0 的待验证智能体不能由普通用户执行。验收完成后可按发布安排恢复平台创建者。",
    "newNote": "新智能体保存为待验证。完成参数、图片和实际生成验收后，再执行上线。",
    "associationNote": "关联会沿用原工作流的发布状态、归属和可见范围。若原工作流已上线，新智能体配置会即时生效；请先完成测试并保留原配置。",
    "confirmAssociationSave": "确认关联并保存智能体",
    "onlineNote": "该智能体已上线。保存会立即更新当前环境中的内容，请先在测试环境验证并保留原发布包。",
    "configNote": "配置需要保留 inputs、outputs 数组。格式化不会改写大整数种子或资源路径。",
    "executionNote": "保留编辑器工作流与执行 API 两份配置；实际节点和输入映射须一致。",
    "required": "请填写{{field}}",
    "loadFailed": "无法加载智能体，请重试。",
    "optionsFailed": "分类、标签或已有工作流未能完整加载，请重试后保存。",
    "saved": "智能体已保存",
    "noChanges": "没有需要保存的修改",
    "saveFailed": "保存失败，修改内容已保留，请重试。",
    "saveUnconfirmed": "保存结果尚未确认",
    "saveUnconfirmedBody": "没有收到明确的保存结果，内容可能已写入。草稿已保留并暂停修改；请先核对保存结果，不要重复提交。",
    "saveStillUnconfirmed": "当前内容尚不能确认与本次提交一致，或读取暂不可用。草稿仍保留；可继续只读核对，或关闭窗口后在列表查看当前内容。未查到对象不代表原请求已停止。",
    "checkSave": "核对保存结果",
    "saveTargetWorkflowId": "关联工作流 ID",
    "saveChecked": "已核对当前内容与本次提交的字段一致",
    "closeUnconfirmedTitle": "关闭编辑并核对列表？",
    "closeUnconfirmedBody": "原保存结果尚未确认。关闭会丢弃此窗口的草稿；请先在列表核对当前内容，再重新打开编辑。",
    "closeAndCheckList": "关闭并查看列表",
    "keepChecking": "保留草稿继续核对",
    "discardTitle": "放弃未保存的修改？",
    "discard": "放弃修改",
    "keepEditing": "继续编辑",
    "confirmOnlineSave": "更新已上线的智能体？",
    "confirmOnlineBody": "保存后，当前环境会立即使用修改后的内容。请确认已完成测试并保留原发布包。",
    "confirm": "确认",
    "yes": "是",
    "no": "否",
    "cover": "封面",
    "updated": "更新时间",
    "usage": "使用量",
    "operations": "操作",
    "publish": "上线",
    "testStatus": "设为待验证",
    "offline": "下线",
    "statusConfirm": "确认将“{{name}}”设为{{status}}？",
    "statusImpact": "该操作会改变当前环境的可见性和使用入口。",
    "statusSaved": "发布状态已更新",
    "statusFailed": "状态更新失败，请刷新后重试。",
    "deleteConfirm": "删除“{{name}}”？",
    "keepWorkflow": "保留工作流，只删除智能体入口",
    "deleteWorkflow": "同时删除智能体和关联工作流",
    "deleted": "智能体已删除",
    "deleteFailed": "删除失败，请重试。",
    "selectExport": "请选择要导出的智能体",
    "importTitle": "导入智能体发布包",
    "file": "发布包文件",
    "chooseFile": "选择 .tar 发布包",
    "importNote": "从已验证环境导出 .tar 发布包并导入当前环境。相同稳定 ID 更新原对象，保留其当前发布状态；新建对象保存为待验证。",
    "startImport": "开始导入",
    "importBlocked": "待修复",
    "targetUserId": "目标创建者用户 ID",
    "targetGroupId": "目标归属团队 ID",
    "targetSharedGroups": "目标可见团队 ID 列表",
    "officialCreator": "官方创建者",
    "officialScope": "官方归属",
    "noAdditionalTeams": "无额外共享团队",
    "ownershipSource": "来源创建者 {{user}}；来源归属团队 {{group}}；限定可见团队 {{count}} 个。",
    "ownershipHelp": "请从当前环境客户详情核对用户与团队 ID，填写目标归属。官方归属为 0；可见团队填写 JSON 数组。来源 ID 仅供参考，不会自动套用。",
    "ownershipInvalid": "目标归属格式无效，请核对创建者与团队 ID。",
    "ownership_invalidId": "{{field}} 必须是完整的整数 ID。",
    "ownership_invalidIdList": "目标可见团队必须是有效 ID 的 JSON 数组，不能重复、含 0 或超过 100 个。",
    "ownership_privateGroup": "来源内容属于团队，请指定目标归属团队，不能改为官方公开范围。",
    "ownership_teamCreator": "团队智能体请选择该团队中的维护者，不能使用官方创建者 0。",
    "ownership_privateAudience": "来源限定了可见团队，请指定目标可见团队，不能清空为公开范围。",
    "ownership_uncheckedOwnership": "请先核对所有目标创建者与团队，再重新检查发布包。",
    "ownershipReadFailed": "目标归属核对失败。请确认用户、团队与成员状态后重试。",
    "checkOwnership": "核对目标归属",
    "ownershipChecked": "目标归属已核对",
    "ownershipRecheck": "归属已修改，请重新检查发布包；旧预检不能确认导入。",
    "confirmOwnershipTitle": "确认当前环境的智能体归属？",
    "confirmOwnershipBody": "导入目标：{{environment}}。以下新建智能体将使用这些创建者、归属团队和可见团队，并保存为待验证。请确认目标账号和接收团队正确。",
    "taskExport": "发布包导出任务",
    "taskImport": "发布包导入任务",
    "taskPending": "处理中，{{processed}} / {{total}}",
    "taskQueued": "排队等待处理",
    "close": "关闭",
    "exportInterruptedShort": "导出中断，需重试",
    "exportInterrupted": "导出执行中断，请重新导出当前内容并核对新的发布包。",
    "exportLimitShort": "导出达到限制，需调整",
    "exportLimit": "导出内容或耗时达到单次限制。请减少选择的智能体或素材后重新导出，并核对新的发布包。",
    "taskDone": "处理结束：{{processed}} / {{total}}",
    "taskPartial": "部分完成：{{count}} 个对象失败，请核对后重试。",
    "taskImportPartial": "部分完成：{{count}} 个对象失败。请核对后只为这些对象重新预检；已成功项不会自动回退。",
    "taskFailed": "处理失败，请检查文件或资源后重试。",
    "taskFailedShort": "处理失败",
    "taskInterruptedShort": "执行中断，需核对",
    "taskInterrupted": "导入执行中断，部分内容可能已保存。请先核对下方对象结果，再重新预检所需内容；不要直接重复覆盖。",
    "taskResultCounts": "已确认成功 {{succeeded}} 项 · 失败 {{failed}} 项 · 待核对 {{unresolved}} 项",
    "taskLastRecordedObject": "最后记录的工作流 ID",
    "taskObjectId": "工作流 ID",
    "taskObjectSucceeded": "已确认成功",
    "taskObjectFailed": "已确认失败",
    "taskObjectUnconfirmed": "待核对",
    "taskUnconfirmedHelp": "未获明确回执不代表没有写入。请回读待核对对象的内容与状态，再只为确需处理的对象重新预检；已成功项不会自动回退。",
    "taskSelectionUnavailable": "这条旧任务没有完整对象清单，请结合原发布批次核对其余对象。",
    "taskReading": "正在读取任务状态…",
    "taskReadFailed": "暂时无法读取进度，任务可能仍在处理。请重试查询。",
    "taskClose": "关闭窗口不会取消后台任务，可从迁移记录继续查看。",
    "download": "下载发布包",
    "downloadFailed": "下载失败，请重试。",
    "taskStarted": "后台任务已启动",
    "taskStartFailed": "未能启动任务，请重试。",
    "noHistory": "暂无迁移记录",
    "exportType": "导出",
    "importType": "导入",
    "failureItems": "失败对象",
    "transferState": "处理状态",
    "upload": "上传图片",
    "uploading": "上传中",
    "uploadDone": "图片已上传",
    "uploadFailed": "图片上传失败，请重试。",
    "uploadType": "请选择 JPG、PNG 或 WEBP 图片",
    "uploadSize": "图片不能超过 10MB",
    "removeCover": "移除封面",
    "error_invalidId": "{{field}}必须是有效的整数 ID，请用字符串保留完整精度。",
    "error_invalidIdList": "{{field}}必须是由整数 ID 组成的 JSON 数组。",
    "error_invalidJson": "{{field}}不是有效的 JSON，请检查格式。",
    "error_jsonObject": "{{field}}必须是 JSON 对象。",
    "error_configArrays": "{{field}}需要 inputs 和 outputs 数组。",
    "error_missingWorkflow": "关联的工作流数据缺失，请刷新列表后重试。",
    "error_invalidCover": "原封面配置无法读取，请检查详情后重试。",
    "error_invalidVisibility": "原展示入口配置无法读取，请检查详情后重试。",
    "error_associationMode": "请选择创建方式。",
    "error_invalidStatus": "请选择有效的发布状态。",
    "listReadFailed": "列表暂时无法更新，当前保留上次结果；请刷新后再修改。",
    "targetEnvironment": "导入目标",
    "CN_TEST": "国内测试环境",
    "INTL_TEST": "国际测试环境",
    "CN_PROD": "国内生产环境",
    "INTL_PROD": "国际生产环境",
    "unknownEnvironment": "无法确认当前环境",
    "previewPackage": "检查发布包与覆盖范围",
    "previewFailed": "暂时无法完成发布包检查，已保留所选文件，请重试。",
    "previewExpired": "预检已过期或无法确认有效期，请重新预检后再确认。",
    "previewIssues": "以下问题需要修复后才能导入",
    "importAction": "导入方式",
    "createNew": "新建",
    "updateExisting": "更新已有对象",
    "transferType": "类型",
    "editNote": "保存仅更新修改的字段，发布状态保持不变。",
    "conflict": "该智能体已被其他操作修改。当前内容已保留，请重新打开详情比较后再保存。",
    "coverEmpty": "暂无封面",
    "coverLoading": "正在加载封面",
    "coverSourceInvalid": "封面地址无效，请核对封面配置。",
    "coverUnavailable": "加载失败",
    "coverReadFailed": "封面暂时无法加载，请重试。",
    "retryCover": "重试加载封面",
    "historyReadFailed": "暂时无法刷新迁移记录，已显示的记录可能不是最新状态。请重试或查看详情核对。",
    "coverPreview": "预览封面",
    "coverCn": "中文",
    "coverEn": "英文",
    "coverSwitch": "切换封面语言",
    "configuration_invalid": "配置校验失败，请检查字段。",
    "configuration_json": "{{path}}：JSON 格式无效。",
    "configuration_object": "{{path}}：需要 JSON 对象。",
    "configuration_graph": "{{path}}：执行图或编辑图结构不完整。",
    "configuration_arrays": "{{path}}：需要 inputs、outputs 数组。",
    "configuration_node": "{{path}}：缺少节点名称或参数数组。",
    "configuration_params": "{{path}}：参数需要标识和类型。",
    "configuration_mapping": "{{path}}：组合参数映射不完整。",
    "configuration_missingNode": "{{path}}：所指节点不存在，请核对两份工作流。",
    "configuration_missingInput": "{{path}}：执行节点中没有对应输入。",
    "configuration_virtualNode": "{{path}}：批量数量节点或参数不正确。",
    "configuration_range": "{{path}}：默认值或数值范围不正确。",
    "configuration_nodeId": "{{path}}：节点 ID 必须是有效整数。",
    "configuration_duplicate": "{{path}}：节点或参数映射重复。",
    "configuration_languageMapping": "{{path}}：中英文配置指向的节点或输入不一致。",
    "replaceOnlineTitle": "替换已上线的智能体内容？",
    "replaceOnlineBody": "目标环境：{{environment}}。其中 {{count}} 个智能体已上线；导入将保留上线状态，并立即使用发布包中的新内容。请确认该发布包已完成测试，并已保留原发布包。"
  },
  "jsonEditor": {
    "empty": "暂无内容",
    "expand": "全部展开",
    "collapse": "全部收起",
    "importFile": "导入文件",
    "importDone": "文件已导入",
    "importFailed": "文件读取失败，请重新选择。",
    "expandBranch": "展开 {{path}}",
    "collapseBranch": "收起 {{path}}",
    "invalid": "JSON 格式错误，请检查内容。",
    "copy": "复制",
    "copied": "已复制到剪贴板",
    "copyFailed": "复制失败，请重试。",
    "download": "下载",
    "downloadDone": "文件已下载",
    "downloadFailed": "下载失败，请重试。",
    "format": "格式化",
    "formatted": "已格式化",
    "editMode": "编辑模式",
    "viewMode": "查看模式",
    "plainText": "纯文本",
    "valid": "格式正确",
    "characters": "字符数：{{count}}"
  }
};
